module.exports = __webpack_public_path__ + "img/ciro-galvez.b4dcaea4.png";